import { render, staticRenderFns } from "./ProjectsMandatory.vue?vue&type=template&id=590f97a6&scoped=true&"
import script from "./ProjectsMandatory.vue?vue&type=script&lang=js&"
export * from "./ProjectsMandatory.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsMandatory.vue?vue&type=style&index=0&id=590f97a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590f97a6",
  null
  
)

export default component.exports